import ServiceHost from "../../di_service/service"
import { IDescriptor } from "../types"
import lawLogo from "./../../assets/logos/law.svg"
import BulgarianLawConnector from "./connector"
import { IBulgarianLawConnector } from "./types"

class BulgarianLawDescriptor implements IDescriptor {
    public name: string = "Bulgarian Law"
    public id: string = "11"
    public color: string = "#ff9999"
    public iconSrc: string = lawLogo
    // tslint:disable-next-line: max-line-length
    public description: string = "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
    public shortDescription: string = "Parse documents with one click"

    public createConnector(id: string): IBulgarianLawConnector {
        return new BulgarianLawConnector({ id, descriptor: this, serviceHost: ServiceHost })
    }
}

export default BulgarianLawDescriptor
